//= Functions & Modules
// Others
import React from 'react';

type Props = {
    inDialog?: boolean;
    className?: string;
};

export class Menu extends React.PureComponent<Props> {
    static defaultProps = {
        inDialog: false,
        className: '',
    };

    render() {
        return (
            <div
                className={`${this.props.inDialog === false ? 'hidden md:flex' : 'flex'} w-52 flex-col flex-shrink-0`}
                style={{ borderRight: '1px solid rgba(255,255,255,0.07)' }}
            >
                <div className="px-3 pt-5 pb-2">
                    <span className="text-xs font-semibold text-unselected1 uppercase tracking-widest px-3">
                        Navigation
                    </span>
                </div>
                <nav className="flex flex-col gap-0.5 px-3 pb-4">
                    {this.props.children}
                </nav>
            </div>
        );
    }
}
